import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { submitSiteSurvey, cancelImageUpload, submitSiteSurveyImages, setDisplaySiteSurveyBanner, submitPlannerSiteSurvey } from '../../application_actions';
import { NoteBox } from '../presentational/note_box.jsx';
import { Navigator } from '../presentational/navigator.jsx';
import SiteSurveyDataLoading from '../update/site_survey_data_loading.jsx';
import { LoadingCircular } from '../presentational/loading.jsx';
import { ConfirmationModal } from '../presentational/confirmation_modal.jsx';
import { ImagePreviewModal } from '../presentational/image_preview_modal.jsx';
import { filterImagesByMachineryType } from '../../helpers/siteSurveyDataMapper.js';
import Form from './site_survey_form.jsx';

var MAX_WIDTH = 1000;
var MAX_HEIGHT = 1000;

var survey_form = {};
import { site_survey_questions } from './site_survey_form_elevator';
import survey_form_escalator from './site_survey_form_escalator';
import makeBasePage from '../base_page.jsx';

let plannerLeadTemplate = {
  "labourHours": null,
  "additionalComments" : "",
  "materials": [],
  "psrPackages":[]
}

export class SiteSurvey extends Component {

  constructor(props) {
    super(props);

    switch (this.props.app.siteSurveyForm) {
      case "ELEVATOR": survey_form = site_survey_questions;
      break;
      case "ESCALATOR": survey_form = survey_form_escalator;
      break;
    }

    this.state = {
      formLayout: survey_form,
      formState: {},
      formModified: true,
      missingFields: [],
      checkBoxes: {},
      plannerLeads: {},
      modal: null
    };
  }

  handleBrowserBackButtonClick() {
    if (window.location.pathname == '/site_survey/data-collection') {
      const leavePage = confirm("Changes you made may not be saved.");
      if (leavePage) {
        history.back(); 
      } else {
        history.pushState(null, document.title, location.href);
      }
    }
  }

  /**
   * Deeply merges two planner leads objects: draftPlannerLeads and previousPlannerLeads.
   *
   * - For each key (e.g., 'landingCallStation'), if the key exists in both objects:
   *   - For object-type values, it merges fields:
   *     - If a field in draft is defined and not empty, it overrides the previous value.
   *     - If a field in draft is an empty array and the previous value is a non-empty array, it retains the previous value.
   *     - Otherwise, it uses the previous value.
   *   - For primitive values (e.g., strings, numbers), if the draft value is defined, it overrides the previous value.
   *     Otherwise, it uses the previous value.
   *
   * @param {Object} draftPlannerLeads - The draft planner leads object.
   * @param {Object} previousPlannerLeads - The previous planner leads object.
   * @returns {Object} - The merged planner leads object.
   *
   * @example
   * const draftPlannerLeads = {
   *   landingCallStation: {
   *     labourHours: 1,
   *     additionalComments: "Updated comment",
   *     materials: [],
   *     psrPackages: []
   *   }
   * };
   *
   * const previousPlannerLeads = {
   *   landingCallStation: {
   *     labourHours: 2,
   *     additionalComments: "Original comment",
   *     materials: [{ name: "Material A", quantity: 5 }],
   *     psrPackages: [{ name: "Package A", quantity: 2 }]
   *   }
   * };
   *
   * const mergedLeads = deepMergePlannerLeads(draftPlannerLeads, previousPlannerLeads);
   * // Result:
   * // {
   * //   landingCallStation: {
   * //     labourHours: 1,
   * //     additionalComments: "Updated comment",
   * //     materials: [{ name: "Material A", quantity: 5 }],
   * //     psrPackages: [{ name: "Package A", quantity: 2 }]
   * //   }
   * // }
   */
  deepMergePlannerLeads(draftPlannerLeads = {}, previousPlannerLeads = {}) {
    const allKeys = new Set([
      ...Object.keys(previousPlannerLeads),
      ...Object.keys(draftPlannerLeads)
    ]);
  
    const mergedPlannerLeads = {};
  
    allKeys.forEach((key) => {
      const draftValue = draftPlannerLeads[key];
      const prevValue = previousPlannerLeads[key];
  
      // If both are objects, do deep merge field-by-field
      if (typeof draftValue === 'object' && !Array.isArray(draftValue) && draftValue !== null) {
        const mergedValue = { ...prevValue };
  
        Object.keys(draftValue).forEach(field => {
          const draftField = draftValue[field];
          const prevField = prevValue?.[field];
  
          mergedValue[field] =
          (Array.isArray(draftField) && draftField.length === 0 && Array.isArray(prevField) && prevField.length > 0)
            ? prevField
            : (draftField !== undefined && draftField !== null && draftField !== '')
              ? draftField
              : prevField;
        });
  
        mergedPlannerLeads[key] = mergedValue;
      } else {
        // Primitive values (e.g., string, number)
        mergedPlannerLeads[key] = (draftValue !== undefined && draftValue !== null)
          ? draftValue
          : prevValue;
      }
    });
  
    return mergedPlannerLeads;
  };

  componentDidMount() {
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', this.handleBrowserBackButtonClick);

    window.onbeforeunload = function(eventObj) {
      eventObj = eventObj || window.event;
      if (eventObj) {
        eventObj.returnValue = 'All your data will be lost! Do you want to leave?';
      }
  
      return 'All your data will be lost! Do you want to leave?';
    };

    // #########################################################################
    // 1st Init default selections for site survey depending of the survey type. 
    // #########################################################################

    // Escalator default values are stored with form definition in site_survey_form_escaltor.js (and not separately like in elevator case)
    if(this.props.app.siteSurveyForm === "ESCALATOR" &&
        !this.props.app?.collectedData?.storedFormState ){

          let escalatorSurveyDefaultValues = {}
          survey_form.map((section)=>{
            section.fields.map((field)=>{
              if(field.defaultSelection){
                escalatorSurveyDefaultValues[field.id] = {value:field.defaultSelection}
              }
              if (field.id === 'escalatorVAsiteSurveyManufacturer') {
                escalatorSurveyDefaultValues[field.id] = this.props.app?.iotData?.equipment?.isKone ?
                    {value: 'yes'} : {value: 'no'};
              }
            })
          })
          this.setState({formState: escalatorSurveyDefaultValues});
    }

    /*
    TODO: Confirm its not in use and remove if not needed
    // Old logic incase elevator site survey where checkboxes are separated from form definition (site_survey_form_elevator.js) 
    if(this.props.app.siteSurveyForm === "ELEVATOR") {
      // Checkboxes are only in use with Elevator site survey
      let initCheckboxes = {}
      Object.keys(this.props.strings.SiteSurveyForm.checkBoxes)
        .map(i => { initCheckboxes[i] = false;})
      this.setState({checkBoxes: initCheckboxes});
    }
    */

    // #########################################################################
    // 2nd retrieve stored selections from redux
    // #########################################################################
    /* If we have earlier filled form and stored values in Redux, get that data and copy to
    component state. Note that refactoring on larger scale should be done to utlize only Redux
    store and refrain of storing values to component states */
    if (Object.keys(this.state.formState).length === 0 && this.props.app.collectedData
      && this.props.app?.collectedData?.siteSurvey && this.props.app.collectedData.storedFormState) {
      const initFormState = this.props.app.collectedData.storedFormState;
      let initCheckboxes = {}
      if (this.props.app.collectedData.storedCheckboxes) {
        initCheckboxes = this.props.app.collectedData.storedCheckboxes
      }
      let initPlannerLeads = {}
      if (this.props.app.collectedData.storedPlannerLeads) {
        initPlannerLeads = this.props.app.collectedData.storedPlannerLeads
      }
      this.setState(
        {
          formState: initFormState,
          formModified: true,
          checkBoxes: initCheckboxes,
          plannerLeads: initPlannerLeads
        });
    }

    this.props.setDisplaySiteSurveyBanner(true);
    let previousFormState = {};
    let previousPlannerLeads = {};
    if (this.props.app.previousSiteSurveyData?.surveyResponses) {
      previousFormState = JSON.parse(
        JSON.stringify(this.props.app.previousSiteSurveyData.transformed)
      );

      previousPlannerLeads = JSON.parse(
        JSON.stringify(this.props.app.previousSiteSurveyData.plannerLeads || {})
      );
    }

    const draftJSON = localStorage.getItem(`siteSurvey-${this.props.app.KEN}`) || `{}`;
    let mergedFormState = JSON.parse(JSON.stringify({ ...previousFormState })); // default if no draft and deep copy
    let plannerLeads = {};

    if (draftJSON) {
      const draft = JSON.parse(draftJSON);
      plannerLeads = draft.plannerLeads;
      const draftPlannerLeads = draft.plannerLeads || {};
      const removedImages = draft.removedImages || [];
      // Merge formState: prefer draft value, fallback to previousFormState
      const allKeys = new Set([
        ...Object.keys(previousFormState || {}),
        ...Object.keys(draft.formState || {})
      ]);

      mergedFormState = {};
      allKeys.forEach((key) => {
        const localValue = draft.formState?.[key];
        const prevValue = previousFormState?.[key];

        mergedFormState[key] = (localValue !== undefined && localValue !== null)
          ? localValue
          : prevValue;
         if (Array.isArray(prevValue?.images) && prevValue.images.length > 0) {
            mergedFormState[key].images = prevValue.images.filter(
              img => !(img.file && img.file.id && removedImages.includes(img.file.id))
            );
          }
      });

      if (Object.keys(draftPlannerLeads).length == 0) {
        plannerLeads = previousPlannerLeads;
      } else {
        const mergedPlannerLeads = this.deepMergePlannerLeads(draftPlannerLeads, previousPlannerLeads);
        plannerLeads = mergedPlannerLeads;
      }
    }

    // Final unified setState
    this.setState({
      formState: mergedFormState,
      previousPlannerLeads: previousPlannerLeads,
      plannerLeads: plannerLeads,
      formModified: true,
      previousFormState: {
        ...previousFormState,
        lastModifiedDate: this.props.app?.previousSiteSurveyData?.lastModifiedDate
      }
    });
  }

  componentWillUnmount() {
    window.addEventListener('popstate', function (e) {});
    window.onbeforeunload = function (e) {
    };
    this.props.setDisplaySiteSurveyBanner(false);
  }

  hasNonOtherValue(id) {

    var result = (
      this.state.formState[id] &&
      this.state.formState[id].value != "OTHER");

    return result;
  }

  hasValue(id) {

    return this.state.formState[id] && this.state.formState[id].value;
  }

  isSelected(id) {

    var result =
      (this.state.formState[id] && this.state.formState[id].value != undefined);

    return result;
  }

  getField(id) {

    var ret = undefined;

    this.state.formLayout.forEach((current_step) => {
      current_step.fields.forEach((current_item) => {
        if (current_item.id == id)
          ret = current_item;
      });
    });

    return ret;
  }

  onPlannerLeadChanged(selection, type, newValueObject) {
    const prevPlannerLeads = this.state.plannerLeads;
    const newPlannerLeads = JSON.parse(JSON.stringify(prevPlannerLeads));
    const fieldId = selection;

    // Initialize entry if missing or during init
    if (!newPlannerLeads[fieldId] || type === "init") {
      newPlannerLeads[fieldId] = JSON.parse(JSON.stringify(plannerLeadTemplate));
    }

    const lead = newPlannerLeads[fieldId];

    const getIndex = (list) => list.findIndex((item) => item.id === newValueObject.id);

    switch (type) {
      case "new_psr":
        lead.psrPackages.push(newValueObject);
        break;
      case "new_material":
        lead.materials.push(newValueObject);
        break;
      case "labour-hours":
        lead.labourHours = newValueObject.value;
        break;
      case "addittional-comments":
        lead.additionalComments = newValueObject.value;
        break;
      case "psr-name":
        lead.psrPackages[getIndex(lead.psrPackages)].name = newValueObject.value;
        break;
      case "psr-quantity":
        lead.psrPackages[getIndex(lead.psrPackages)].quantity = newValueObject.value;
        break;
      case "material-name":
        lead.materials[getIndex(lead.materials)].name = newValueObject.value;
        break;
      case "material-quantity":
        lead.materials[getIndex(lead.materials)].quantity = newValueObject.value;
        break;
      case "psr-delete":
        lead.psrPackages.splice(getIndex(lead.psrPackages), 1);
        break;
      case "material-delete":
        lead.materials.splice(getIndex(lead.materials), 1);
        if (lead.materials.length === 0) {
          lead.labourHours = "";
        }
        break;
      case "init":
        // already handled above
        break;
      default:
        console.warn("Unhandled planner lead change type:", type);
    }

    // Only update state if there are actual changes
    if (JSON.stringify(prevPlannerLeads) !== JSON.stringify(newPlannerLeads)) {
      this.setState(
        {
          plannerLeads: newPlannerLeads,
          formModified: true,
        },
        () => {
          localStorage.setItem(
            `siteSurvey-${this.props.app.KEN}`,
            JSON.stringify(this.state)
          );
        }
      );
    }
  }


  onBoxChecked(value) {

    var newState = this.state.checkBoxes;
    newState[value] = this.state.checkBoxes[value] ? false : true;
    this.setState({ checkBoxes: newState });
  }

  onValueChange(field, data) {
    if (!field || !data || data.value === undefined) return;

    const fieldId = field.id;
    let updatedFormState = { ...this.state.formState };
    let shouldUpdate = false;

    // Handle empty value (removal)
    if (data.value === '') {
      if (updatedFormState[fieldId] !== undefined) {
        delete updatedFormState[fieldId];
        shouldUpdate = true;
      }
    } else {
      let newFieldState = { ...(updatedFormState[fieldId] || {}) };
      newFieldState.key = data.key;
      newFieldState.value = data.value;

      if (field.type === 'number') {
        this.saveNumberValue(field, updatedFormState, newFieldState, data);
        return; // saveNumberValue handles setState
      } else if (field.type === 'dropdown') {
        this.saveDropdownValue(field, updatedFormState, newFieldState);
        return; // saveDropdownValue handles setState
      } else {
        if (data.valid !== undefined) {
          newFieldState.valid = data.valid;
        }
        updatedFormState[fieldId] = newFieldState;
        shouldUpdate = true;
      }
    }

    if (shouldUpdate) {
      this.setState({
        formState: updatedFormState,
        formModified: true
      }, () => {
        // Save updated state to localStorage after state is applied
        localStorage.setItem(`siteSurvey-${this.props.app.KEN}`, JSON.stringify(this.state));
      });
    }
  }


  saveDropdownValue(field, newState, newFieldState) {
    const fieldId = field?.id;
    if (!fieldId) return;

    // Clone state
    const updatedFormState = JSON.parse(JSON.stringify(newState));
    const updatedPlannerLeads = { ...this.state.plannerLeads };

    // Clear planner lead incase dropdown selection is changed
    if (updatedPlannerLeads[fieldId]) {
      delete updatedPlannerLeads[fieldId];
    }

    // Incase dropdown value CLEAR, remove this selection alltogether
    if (newFieldState.value === "CLEAR") {
      delete updatedFormState[fieldId];
    } else {
      updatedFormState[fieldId] = newFieldState;
    }

    this.setState(
      {
        formState: updatedFormState,
        plannerLeads: updatedPlannerLeads,
        formModified: true,
      },
      () => {
        // Save updated state to localStorage after state is applied
        localStorage.setItem(
          `siteSurvey-${this.props.app.KEN}`,
          JSON.stringify(this.state),
        );
      },
    );
  }


  saveNumberValue(field, newState, newFieldState, data){
    if (newFieldState.value == ""){
      newFieldState.value = undefined;
    }

    const value = newFieldState.value;
    const fieldId = field?.id;

    if (data.valid !== undefined) {
      newFieldState.valid = data.valid;
    }

    newState[fieldId] = newFieldState;

    const updatedState = {
      formState: newState,
      formModified: true,
    };

    // Clear planner lead incase number (year) length is less than 4.
    if (
      value &&
      field.minLength &&
      value.length <= field.minLength &&
      this.state.plannerLeads?.[fieldId]
    ) {
      const newPlannerLeads = JSON.parse(JSON.stringify(this.state.plannerLeads));
      delete newPlannerLeads[fieldId];
      updatedState.plannerLeads = newPlannerLeads;
    }
    
    this.setState(updatedState, () => {
      // Save updated state to localStorage after state is applied
      localStorage.setItem(
        `siteSurvey-${this.props.app.KEN}`,
        JSON.stringify(this.state),
      );
    });
  }

  removeImage(imageFile, fieldName) {
    var formState = this.state.formState;
    if (!formState[fieldName] || !formState[fieldName].images)
      return;

    formState[fieldName].images = formState[fieldName].images.filter(candidate => {
      return candidate.file.preview != imageFile.file.preview;
    });

    const removedImages = [...(this.state.removedImages || [])];
    if (imageFile?.file?.isExistingImage) {
      removedImages.push(imageFile.file.id);
    }

    // Update state and localStorage
    this.setState({ formState, removedImages }, () => {
      localStorage.setItem(
        `siteSurvey-${this.props.app.KEN}`,
        JSON.stringify(this.state)
      );
    });
  }

  onRemoveImageCLicked(imageFile, fieldName) {
    this.setState({
      removeImageModal: (<ConfirmationModal
        title={this.props.strings.Common.removeImage}
        confirmText={this.props.strings.Common.ok}
        cancelText={this.props.strings.Common.cancel}
        onConfirm={() => this.removeImage(imageFile, fieldName)}
        onCancel={() => {
          this.setState({ removeImageModal: null });
        }}
        onClose={() => {
          this.setState({ removeImageModal: null });
        }}
        visible={true}
      />)
    });
  }

  onImageClicked(imageFile, fieldName) {
    this.setState({
      modal: (<ImagePreviewModal
        title={this.props.strings.Common.removeImage}
        confirmText={this.props.strings.Common.ok}
        cancelText={this.props.strings.Common.cancel}
        imgFile={imageFile.file}
        imgHelptext={ this.props.strings.Common?.imageFromLastSurvey }
        onConfirm={() => this.onRemoveImageCLicked(imageFile, fieldName)}
        onCancel={() => {
          this.setState({ modal: null });
        }}
        onClose={() => {
          this.setState({ modal: null });
        }}
        visible={true}
      />)
    });
  }

  onImageDrop(imageFile, fieldName, objectUrl) {

    var formState = this.state.formState;

    if (!formState[fieldName])
      formState[fieldName] = {};

    if (!formState[fieldName].images)
      formState[fieldName].images = [];

    /* Maximum number of images is 5 */
    if (formState[fieldName].images.length > 4)
      return;

    /* Resize the image to a reasonable size, as photographs taken on
      a mobile phone can be several megabytes */
    var img = new Image();
    img.crossOrigin = "anonymous";
    
    img.onload = e => {

      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var width = img.width;
      var height = img.height;

      if (width > height) {
          if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
          }
      } else {
          if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
          }
      }
      canvas.width = width;
      canvas.height = height;

      ctx.drawImage(img, 0, 0, width, height);
      ctx.canvas.toBlob((blob) => {
          var resized = new File([blob], `${imageFile[0].name}_${Date.now()}`);
          if (objectUrl && objectUrl.length > 0) {
            resized.preview = objectUrl;
          } else {
            resized.preview = URL.createObjectURL(imageFile[0]);
          }

          formState[fieldName].images.push({ file: resized });

          this.setState({
            formState,
            formModified: true
          });

          localStorage.setItem(`siteSurvey-${this.props.app.KEN}`, JSON.stringify(this.state));
      }, 'image/jpeg', 1);
    }

    if (objectUrl && objectUrl.length > 0) {
      img.src = objectUrl;
    } else {
      img.src = URL.createObjectURL(imageFile[0]);
    }
  }

  failedImageUploads() {

    var failedImages = [];

    for (var step = 0; step < this.state.formLayout.length; step++) {
      var current_step = this.state.formLayout[step];

      for (var item = 0; item < current_step.fields.length; item++) {
        var current_item = current_step.fields[item];

        if (current_item.type == "image" &&
            this.props.koneEquipment.KENData &&
            this.props.koneEquipment.KENData[current_item.id] &&
            this.props.koneEquipment.KENData[current_item.id].image &&
            this.props.koneEquipment.KENData[current_item.id].image.uploadSuccesfull == false) {
          failedImages.push(this.props.strings.plannerSiteSurveyQuestions.fields[current_item.id] || current_item.id)
        }
      }
    }

    return failedImages;
  }

  getContinueButtonText() {

    var buttonText = this.props.strings.Common.submit;

    if (!this.state.formModified) {
      buttonText = this.props.strings.Common.continue;
    }

    return buttonText;
  }

  continueDisabled() {
    return !this.props.app.internetStatus;
  }

  checkPlannerLeadMandatoryFields(plannerLead){  
    let returnValue = true

    const evaluatePsrsAndMaterials = (key) => {
      plannerLead[key].forEach(item => {
        !item.quantity && item.quantity === "" ? returnValue = false : null
        !item.name && item.name === "" ? returnValue = false : null
      })
    }

    // Quantity is mandatory
    if(plannerLead.psrPackages.length > 0){
      evaluatePsrsAndMaterials("psrPackages")
    }
    if(plannerLead.materials.length > 0){
      evaluatePsrsAndMaterials("materials")
    }
    
    // If any materials are set, then labour hours is mandatory
    if(plannerLead.materials.length > 0 && (!plannerLead.labourHours || plannerLead.labourHours === "")){
      returnValue = false
    }
    
    // If any material or PSR package is missing name field, then additional comments is mandatory
    if(!plannerLead.additionalComments || plannerLead.additionalComments.length < 1 ){
      plannerLead.materials.forEach(item => {
        !item.name || item.name === "" ? returnValue = false : null
      });
      plannerLead.psrPackages.forEach(item => {
        !item.name || item.name === "" ? returnValue = false : null
      });
    }

    // If plannerLead is empty, then at least additional comments is mandatory
    if(plannerLead.materials.length < 1 && plannerLead.psrPackages.length < 1 && (!plannerLead.additionalComments || plannerLead.additionalComments.length < 1)){
      returnValue = false
    } 
    return returnValue
  }

  filterSteps() {
    let filteredSteps = this.state.formLayout.filter(step => {
      if (step.requiresKey !== undefined) {
        if (this.state.formState[step.requiresKey] && 
          this.state.formState[step.requiresKey].value === step.requiresValue) {
          return true;
        } else {
          return false;
        }
      }
  
      return true;
    });

    return filteredSteps;
  }

  checkMandatoryFields() {
    let missingFields = []
    
    // For now, only one field will be mandatory. Rest might be added during further revisions.

    /*const getMissingFieldTranslation = (key) => {
      const mandatoryFieldMissingPrefix = this.props.strings?.plannerLeads?.general?.mandatoryFieldMissing || ""
      const questionText = this.props.strings.SiteSurveyForm?.fields[key] || key
      return `${mandatoryFieldMissingPrefix} (${questionText})`
    }

    for (const [key, value] of Object.entries(this.state.plannerLeads)) {
      this.checkPlannerLeadMandatoryFields(value) ? null : missingFields.push(getMissingFieldTranslation(key))
    }*/

    if (this.state.formState['carPictureCopKen'] === undefined) {
      missingFields.push('Picture of whole COP and KEN'); // This will be replaced when the translation tool is integrated
    }

    this.setState({
      missingFields: missingFields
    });
    if (missingFields.length > 0) {
      window.scrollTo(0, 0);
    }
    return missingFields.length === 0 ? true : false
  }

  saveData() {

    if (!this.checkMandatoryFields())
      return;

    let completeData = this.state.formState;
    const formState = this.state.formState;
    const plannerLeads = this.state.plannerLeads;

    this.setState({ onSurveyLoad: true, onImageLoad: true, surveySendFailed: false });

    this.props.submitPlannerSiteSurvey(completeData, this.props.app.iotData.key, formState, plannerLeads, this.props.app.SO)
      .then(() => {
        this.props.setDisplaySiteSurveyBanner(false);
        localStorage.removeItem(`siteSurvey-${this.props.app.KEN}`);
        this.setState({ onSurveyLoad: false });
        this.submitImages(completeData);
      }).catch((err) => {
        this.setState({ onSurveyLoad: false, surveySendFailed: true });
      })
  }

  submitImages(formState, retry) {
    this.setState({ onImageLoad: true });
    const dataWithFilteredImages = filterImagesByMachineryType(formState);
    this.props
      .submitSiteSurveyImages(
        dataWithFilteredImages,
        this.props.app?.collectedData,
        this.props.app.iotData.key,
        this.props.app.surveyId,
        this.props.app.pdmSurveyId,
        retry ?? false,
      )
      .then(() => {
        this.setState({ onImageLoad: false });
        this.props.goForward();
      })
      .catch((err) => {
        this.setState({ onImageLoad: false, imageUploadFailed: true });
      });
  }

  skipImageUpload(){
    this.props.goForward();
  }

  retrySubmitImages(){
    this.setState({ imageUploadFailed: undefined });
    this.submitImages(this.props.app?.collectedData?.siteSurvey, true)
  }

  totalImages() {

    var total = 0;
    if (this.props.app?.collectedData?.siteSurvey){
      Object.keys(this.props.app?.collectedData?.siteSurvey).forEach(k => {
        var item = this.props.app.collectedData.siteSurvey[k];
        if (item.images && item.images.length > 0)
          total += item.images.length;
      });
    }
    return total;
  }

  loadedImages() {

    var total = 0;
    if (this.props.app?.collectedData?.siteSurvey){
      Object.keys(this.props.app.collectedData.siteSurvey).forEach(k => {
        var item = this.props.app.collectedData.siteSurvey[k];
        if (item.images && item.images.length > 0) {
          item.images.forEach(item => {
            if (item.uploadSuccesfull === true)
              total += 1;
          })
        }
      });
    }

    return total;
  }

  canceledImages() {

    var total = 0;
    if (this.props.app?.collectedData?.siteSurvey){
      Object.keys(this.props.app.collectedData.siteSurvey).filter(k => {
        var item = this.props.app.collectedData.siteSurvey[k];
        if (item.images && item.images.length > 0) {
          item.images.forEach(item => {
            if (item.uploadSuccesfull === false)
              total += 1;
          })
        }
      });
    }
    return total;
  }

  getNotifications() {

    return (
    <div>
      { this.props.app.formUploadError ?
        <NoteBox
          data={[
            { "text": this.props.strings.DataCollection.formUpdateError }
          ]}
          theme="warning"
        /> : null
      }
      { this.state.missingFields && this.state.missingFields.length > 0 ?
        <NoteBox
          data={[
            {
              "text": "Please select a value for the following fields: ",
              "list": this.state.missingFields
            }
          ]}
          theme="warning"
        /> : null }
    </div>);
  }

  render() {

    if ( (this.state.onSurveyLoad || this.state.onImageLoad || this.state.imageUploadFailed)
        && !this.state.surveySendFailed) {

      return <SiteSurveyDataLoading
        strings = { this.props.strings }
        loadedImagesCount = { this.loadedImages() }
        totalImageCount = { this.totalImages() }
        canceledImagesCount = { this.canceledImages() }
        cancelImageUpload = { () => { this.props.cancelImageUpload("siteSurvey") } }
        onSurveyLoad = { this.state.onSurveyLoad }
        onImageLoad = {this.state.onImageLoad}
        skipImageUpload = { () => this.skipImageUpload() }
        retryImageUpload = { () => this.retrySubmitImages() }
        imageUploadFailed = { this.state.imageUploadFailed }
      />;
    }

    if (!this.state.formLayout) {
      return <LoadingCircular/>;
    }

    return (
      <div className="page-view" id= "siteSurveyDataCollection">
        <div>
          <h1 className="title">{this.props.strings.DataCollection.dataCollectionTitle}</h1>
          { this.state.modal }
          { this.state?.removeImageModal }
          { this.getNotifications() }
          {
            (this.props.app.siteSurveyForm === "ELEVATOR") && (
              <>
                {
                  this.props?.app?.previousSiteSurveyData && (() => {
                    const lastModifiedDate = this.props.app.previousSiteSurveyData?.lastModifiedDate;
                    const formattedDate = lastModifiedDate ? new Date(lastModifiedDate).toLocaleDateString('en-GB') : null;
                    const lastSurveyTaken = this.props?.strings?.Common?.lastSurveyTaken || "Last survey taken on";
                    return (
                      <div className="last-survey-taken">
                        {lastSurveyTaken} {formattedDate}
                      </div>
                    );
                  })()
                }
                <Form
                  equipment={this.props.app?.iotData?.equipment}
                  formLayout={this.filterSteps()}
                  formState={this.state.formState}
                  previousFormState={this.state.previousFormState}
                  previousPlannerLeads={this.state.previousPlannerLeads}
                  disabled={false}
                  onValueChange={(field, data) => this.onValueChange(field, data)}
                  onImageDrop={(imageFile, fieldName) => this.onImageDrop(imageFile, fieldName)}
                  onImageClicked={(imageFile, fieldName) => this.onImageClicked(imageFile, fieldName)}
                  onBoxChecked={(value) => this.onBoxChecked(value)}
                  strings={this.props.strings.plannerSiteSurveyQuestions}
                  plannerLeadsStrings={this.props.strings.plannerLeads}
                  commonStrings={this.props.strings.Common}
                  checkBoxes={this.state.checkBoxes}
                  onPlannerLeadChanged={(selection, type, value) => this.onPlannerLeadChanged(selection, type, value)}
                  plannerLeads={this.state.plannerLeads}
                  showCheckBoxes={this.props.app.siteSurveyForm === "ELEVATOR"}
                />
              </>
            )
          }

          <Navigator
            continueText={ this.getContinueButtonText() }
            backText={this.props.strings.Common.back}
            onContinue={() => this.saveData() }
            onBack={() => history.back() }
            continueDisabled={ this.continueDisabled() }
          />
        </div>
      </div>
    )
  }
}

function mapStateToProps({ siteSurveyAlert }) {
  return { siteSurveyAlert };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({ submitSiteSurvey, submitSiteSurveyImages, cancelImageUpload, setDisplaySiteSurveyBanner, submitPlannerSiteSurvey }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(makeBasePage('SiteSurvey')(SiteSurvey));
